import {
  Input,
  Output,
  EventEmitter,
  Component,
  OnInit,
  ChangeDetectionStrategy,
  AfterViewInit
} from '@angular/core';
import { DynamicFormItem } from '@ispm/dynamic-form/classes/dynamic-form-item.class';
import { ISelectable } from '../../interfaces/selectable.interface';
import { TitleItem } from '../../classes/title-configuration.class';
import { TherapiesActionCreatorService } from '@ispm/therapies/services/therapies-action-creator.service';
import { Observable } from 'rxjs/Observable';
import { flatMap, take } from 'rxjs/operators';
import { FormHandlerService } from '@ispm/dynamic-form/services/form-handler.service';
import { isEmpty } from 'lodash';

@Component({
  selector: 'gen-information-card',
  templateUrl: './information-card.component.html',
  styleUrls: ['./information-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InformationCardComponent implements ISelectable, AfterViewInit, OnInit {
  public cardLayoutClass: any;
  public headerCss: any;
  public isFullWidth: boolean;
  public isVertical: boolean;
  public isSelected$: Observable<boolean>;

  private _data: any;
  private _titles: TitleItem[];

  @Input()
  public set data(data: any) {
    if (!isEmpty(data)) {
      this._data = data;
      this.isSelected$ = this._therapiesAC.getIsSelectedStream(TherapiesActionCreatorService.getTherapyIdentifier(this.data));
    }
  }

  public get data() {
    return this._data;
  }

  @Input('identifier')
  public _identifier: string;

  @Input()
  public selectable: boolean = false;

  @Input()
  public expended: boolean = false;

  @Input()
  public shortFormConfig: DynamicFormItem[];

  @Input()
  public isSelectable: boolean;

  @Input()
  public formId: string;

  @Input()
  public formConfig: DynamicFormItem[];

  @Input()
  public hideMoreInfo: false;

  @Input()
  public selectByDefault: false;

  @Input()
  public cardLayerConfig;

  @Input()
  public set titles(titles: Array<TitleItem>) {
    this._titles = !isEmpty(titles) ? titles.map(title => new TitleItem(title.text, title.link, this.data)) : [];
  }

  @Output()
  onDeselect: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  onSelect: EventEmitter<any> = new EventEmitter<any>();

  public get titles() {
    return this._titles;
  }

  public get identifier() {
    return this.formId || this._identifier;
  }

  ngOnInit(): void {
    this.headerCss = this.getHeaderCss();
    this.cardLayoutClass = this.getCardLayoutCLass();

    if (this.cardLayerConfig) {
      this.isFullWidth = this.cardLayerConfig.formItemFullWidth ? this.cardLayerConfig.formItemFullWidth : false;
      this.isVertical = !!this.cardLayerConfig.formVertical;
    }
  }

  constructor(
    private _formHandler: FormHandlerService,
    private _therapiesAC: TherapiesActionCreatorService
  ) {
  }

  selectUpdated(status: boolean) {
    status
      ? this.onSelect.emit(this.data)
      : this.onDeselect.emit(this.data);
  }

  showMoreInfo() {
    this.isSelected$.pipe(
      take(1),
      flatMap((isSelected: boolean) => this.popupModal(isSelected))
    ).subscribe();
  }

  popupModal(isSelected: boolean) {
    return this._formHandler.popupDynamicFormModal(
      this.titles.map(title => title.text).join(' '),
      this.formId || this.formConfig,
      this.data,
      null,
      null,
      { editMode: true, disabled: true }
    );
  }

  ngAfterViewInit(): void {
    if (this.selectByDefault && this.data && this.selectable) {
      this.onSelect.emit(this.data);
    }
  }

  getHeaderCss() {
    if (this.cardLayerConfig && this.cardLayerConfig.headerCss) {
      return this.cardLayerConfig.headerCss;
    }

    return 'card-header' ;
  }

  getCardLayoutCLass() {
    if (this.cardLayerConfig && this.cardLayerConfig.cardLayout) {
      return this.cardLayerConfig.cardLayout;
    }

    return 'info-card-wrapper card-layout';
  }
}
